import { Stack } from "@volca/ui/components/ui/stack";
import { SwitchWithLabel } from "@volca/ui/components/ui/switch-with-label";
import { Text } from "@volca/ui/components/ui/text";
import { SectionHeading, SectionLabel } from "@/accounts-payable/common";
import type {
  ApVendor,
  ApVendorUpdate,
  ApVendorListEdit,
} from "@/accounts-payable/types";
import { EditableChips } from "./editable-chips";

export const IncomingEmailSection = ({
  vendor,
  onUpdate,
  onEditList,
}: {
  vendor: ApVendor;
  onUpdate: (changes: ApVendorUpdate) => void;
  onEditList: (edit: ApVendorListEdit) => void;
}) => (
  <Stack className="w-full" align="start" gap={2}>
    <SectionHeading>Incoming email</SectionHeading>
    <SwitchWithLabel
      label="Process emails from this vendor"
      aria-label="Process emails from this vendor"
      checked={vendor.active}
      onChange={(active) => onUpdate({ active })}
    />
    <SectionLabel>Email aliases</SectionLabel>
    <Text variant="caption" tone="muted">
      Invoices from these addresses are recognized as this vendor.
    </Text>
    <EditableChips
      values={vendor.email_aliases ?? []}
      noun="address"
      placeholder="name@vendor.com"
      onAdd={(value) =>
        onEditList({ field: "email_aliases", action: "add", value })
      }
      onRemove={(value) =>
        onEditList({ field: "email_aliases", action: "remove", value })
      }
    />
  </Stack>
);
